import type { TFunction } from 'i18next';
import type { TutorSkill } from '../models/Tutor';
import { tutorSkillLabel } from './tutorSkillI18n';

export const TUTOR_SKILLS: TutorSkill[] = [
  'PIANO',
  'ACOUSTIC_GUITAR',
  'ELECTRIC_GUITAR',
  'BASS_GUITAR',
  'VOCALS',
  'DRUMS',
  'SONGWRITING',
  'MUSIC_THEORY',
  'MUSIC_PRODUCTION',
  'MIX_AND_MASTERING',
  'BEATMAKING',
  'VIOLIN',
  'VIOLA',
  'CELLO',
  'DOUBLE_BASS',
  'SAXOPHONE',
  'TRUMPET',
  'TROMBONE',
  'CLARINET',
  'FLUTE',
  'UKULELE',
  'HARMONICA',
  'ORGAN',
  'POP_VOCALS',
  'ROCK_VOCALS',
  'JAZZ_VOCALS',
  'CLASSICAL_VOCALS',
  'OPERA_VOCALS',
  'MUSICAL_THEATRE_VOCALS',
  'RNB_VOCALS',
  'RAP_VOCALS',
  'EXTREME_VOCALS',
];

const POPULAR_TUTOR_SKILLS: TutorSkill[] = [
  'VOCALS',
  'PIANO',
  'ACOUSTIC_GUITAR',
  'DRUMS',
];

export interface TutorSkillOption {
  code: TutorSkill;
  label: string;
  section: 'popular' | 'all';
}

export function getTutorSkillOptions(t: TFunction, locale: string): TutorSkillOption[] {
  const popularSet = new Set<TutorSkill>(POPULAR_TUTOR_SKILLS);
  const popularOptions = POPULAR_TUTOR_SKILLS.map((code) => ({
    code,
    label: tutorSkillLabel(t, code),
    section: 'popular' as const,
  }));

  const allOptions = TUTOR_SKILLS.filter((code) => !popularSet.has(code))
    .map((code) => ({
      code,
      label: tutorSkillLabel(t, code),
      section: 'all' as const,
    }))
    .sort((a, b) => a.label.localeCompare(b.label, locale.replace(/_/g, '-'), { sensitivity: 'base' }));

  return [...popularOptions, ...allOptions];
}
